import { AxiosResponse } from 'axios'

import { connectInternalApi } from 'common/api'

export interface TokenResponse {
  customer_identifier: string
  _id: string
  name: string
  token: string
  expires: string
}
export interface Token {
  id: string
  name: string
  token: string
  expires: string
}

export const getTokens = async (
  accountId: string
): Promise<AxiosResponse<TokenResponse[]>> => {
  return connectInternalApi.get<TokenResponse[]>(
    `v1/core/main/accounts/${accountId}/tokens`
  )
}

export const generateToken = async ({
  name,
  accountId,
}: {
  name: string
  accountId: string
}): Promise<AxiosResponse<TokenResponse>> => {
  return connectInternalApi.post<TokenResponse>(
    `v1/core/main/accounts/${accountId}/tokens`,
    {
      name,
    }
  )
}

export const deleteToken = async ({
  id,
  accountId,
}: {
  id: string
  accountId: string
}) => {
  return connectInternalApi.delete(
    `v1/core/main/accounts/${accountId}/tokens/${id}`
  )
}
